import React from 'react';
import classNames from 'classnames';

import { DynamicMediaItem } from '@uncinc/react-drupal-core';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { ButtonWrapper } from '../../../components';
import type { NodeAnnualReport as Type } from '../../../types/uncinc_profile/nodes';

interface AnnualReportProps {
  entity: ImmutableEntity<Type>;
  className?: string;
}

const NodeAnnualReport: React.FC<AnnualReportProps> = ({ entity, className }) => {
  // TODO: This component was quickly thrown together so it looks somewhat representable.
  // It is far from finished.

  const annualReport = entity.toJS();
  const title = annualReport.title[0].value;
  const media = annualReport.field_media_item[0];
  const link = annualReport.field_link[0];
  const linkUrl = link?.alias || link?.uri;
  const linkTitle = link?.title;
  const classes = classNames('Node', 'NodeAnnualReport', className);

  return (
    <div className={classes}>
      <Container>
        <div className="row">
          {media && (
            <div className="col-12 col-md-4 offset-md-1">
              <DynamicMediaItem
                className="NodeAnnualReport__hero__image"
                media={media}
                imageAspectRatio="1_1"
                aboveTheFold
              />
            </div>
          )}
          <div className="col-12 col-md-8 offset-md-1">
            <h1>{title}</h1>

            {link && (
              <ButtonWrapper href={linkUrl}>
                {linkTitle}
              </ButtonWrapper>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NodeAnnualReport;
